module.exports = __webpack_public_path__ + "img/foreground-desktop.bc19f61.webp";